import { assert } from '../../../app/logger.js';
import { Coords } from '../../coords.js';

/**
 * Marker base class for maps API wrappers.
 */
const MarkerBaseMixin = Base =>
  class extends Base {
    constructor(options) {
      super(options);

      assert(options, `[map:marker] no options is given for MarkerBaseMixin`);
      assert(options.map, `[map:marker] no map is given for MarkerBaseMixin`);
      this.map = options.map;
    }

    get type() {
      return 'marker';
    }

    /**
     * Returns geo coordinates and marker's position relative map's center if
     * the marker is visible and is in view.
     */
    async getInViewPos() {
      if (!this.attached || !this.visible) {
        return null;
      }

      let pos = this.position;
      if (!pos) {
        return null;
      }

      let { lat, lng } = pos;
      let [x, y] = await Coords.toClient(this.map, lat, lng);

      let rect = this.map.el.getBoundingClientRect();
      if (x < 0 || x > rect.width || y < 0 || y > rect.height) {
        return null;
      }

      let centerX = Math.round((rect.right - rect.left) / 2);
      let centerY = Math.round((rect.bottom - rect.top) / 2);

      return {
        lat,
        lng,
        x: x - centerX,
        y: y - centerY,
      };
    }
  };

export { MarkerBaseMixin };
